import LoyaltyAvatarList from "components/molecules/LoyaltyAvatarList";
import { ILoyaltyAvatarListItem } from "types/Loyalty";

type LoyaltyAvatarDesktopProps = {
  activeId: string | null;
  mascots: ILoyaltyAvatarListItem[];
  onHandleSelect: (id: string) => void;
};

const LoyaltyAvatarDesktop = (props: LoyaltyAvatarDesktopProps) => {
  const { activeId, mascots, onHandleSelect } = props;

  return (
    <LoyaltyAvatarList
      list={mascots}
      selected={activeId}
      handleSelect={onHandleSelect}
    />
  );
};

export default LoyaltyAvatarDesktop;
